export default {
  dropDown: {
    position: 'absolute',
    zIndex: 1,
    minWidth: '16.79rem',
    backgroundColor: 'white',
    textAlign: 'left',
    margin: '3rem 0 0 3rem',
    right: '3.6rem',
    padding: '0.25rem'
  },
  dropDownItem: {
    whiteSpace: 'nowrap',
    display: 'inline',
    height: '5rem'
  },
};
